import { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";

import { AddressesAPI } from "../../providers/AddressesAPI";
import { Input } from "../components/Input";

import styles from "../../styles/search-addresses.module.scss";
import { Message } from "../components/Message";

import { Button } from "@components";
import classNames from "classnames/bind";
import { formatAddress } from "./service/Service";
const cx = classNames.bind(styles);

export default function SearchAddressesLocation({
  setSelectedAddress,
  selectedAddress,
}) {
  const [sessionToken, setSessionToken] = useState("");
  const [searching, setSearching] = useState(false);
  const [addressString, setAddressString] = useState("");
  const [addressNumber, setAddressNumber] = useState("");
  const [missingAddressNumber, setMissingAddressNumber] = useState(false);
  const [lastScheduledSearch, setLastScheduledSearch] = useState();
  const [addressesOptions, setAddressesOptions] = useState([]);
  const [preSelectedAddress, setPreselectedAddress] = useState();
  const [addressNumberError, setAddressNumberError] = useState({
    message: "eerror",
    status: false,
  });

  useEffect(() => {
    if (selectedAddress) {
      setAddressString(formatAddress(selectedAddress));
      setAddressNumber(selectedAddress.number);
      if (!selectedAddress.number) setMissingAddressNumber(true);
      else setMissingAddressNumber(false);
    }
  }, [selectedAddress]);

  const generateSessionToken = async () => {
    setSessionToken(uuidv4());
  };

  const searchAddresses = async () => {
    await generateSessionToken();

    setAddressesOptions([]);

    if (addressString.length < 3) {
      setSearching(false);
      return;
    }

    setSearching(true);

    if (lastScheduledSearch) {
      clearInterval(lastScheduledSearch);
      setLastScheduledSearch();
    }

    setLastScheduledSearch(
      setTimeout(async () => {
        const response = await AddressesAPI.searchAddresses(
          addressString,
          sessionToken,
        );
        const addresses = response.getData({});
        if (addresses.length > 0) setAddressesOptions(addresses);
        else
          setAddressesOptions([{ description: "Nenhum endereço encontrado." }]);
        setSearching(false);
      }, 1000),
    );
  };

  const onSelectAddress = async (address) => {
    const response = await AddressesAPI.getAddressById(
      address.id,
      sessionToken,
    );
    const result = response.getData({});
    setAddressString(result.formattedAddress);
    setAddressesOptions([]);
    if (!result.address?.number && !addressNumber) {
      setPreselectedAddress(address);
      setSelectedAddress?.(null);
      setMissingAddressNumber(true);
    } else {
      result.address.number = result.address.number || addressNumber;
      setSelectedAddress?.(result.address);
      setAddressNumber(result.address.number);
      setMissingAddressNumber(false);
    }

    return result;
  };

  const searchByAddressNumber = async () => {
    setAddressNumberError({
      message: "",
      status: false,
    });
    if (!addressNumber) {
      setAddressNumberError({
        message: "Por favor, informe o número!",
        status: true,
      });
      return;
    }
    const formatedAddress = `${preSelectedAddress.formattedText.primary} ${addressNumber} - ${preSelectedAddress.formattedText.secondary}`;
    const searchAddress = await AddressesAPI.searchAddresses(
      formatedAddress,
      sessionToken,
    );
    const address = searchAddress.getData({})[0];
    await onSelectAddress(address);
  };

  return (
    <>
      <div className={styles.searchContainer}>
        <div
          className={cx({
            searchForm: true,
            column: true,
          })}
        >
          <div className={styles.searchAddresses}>
            <div className="d-flex flex-column w-100">
              <Input
                name="address"
                design="three"
                placeholder="Buscar endereço e número"
                className="flex-1"
                value={addressString || ""}
                onChange={(e) => setAddressString(e.target.value)}
                onKeyUp={searchAddresses}
              />
              {addressesOptions && addressesOptions.length > 0 && (
                <div className={styles.inputOptions}>
                  <ul>
                    {addressesOptions.map((option) => (
                      <li
                        key={option.id}
                        onClick={() => onSelectAddress(option)}
                      >
                        {option.description}
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              {searching && (
                <div className={styles.optionsLoading}>
                  <ul>
                    {[1, 2, 3].map((item) => (
                      <li key={item}>
                        <div className={styles.shimmerLineSmall}></div>
                        <div className={styles.shimmerLine}></div>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
            {missingAddressNumber && (
              <Input
                name="number"
                design="two"
                className="ml-15"
                placeholder="n.º"
                value={addressNumber || ""}
                onChange={(e) => setAddressNumber(e.target.value)}
              />
            )}
          </div>
          {missingAddressNumber && (
            <Button design="primary" onClick={searchByAddressNumber}>
              Confirmar
            </Button>
          )}
        </div>

        {addressNumberError.status && (
          <Message className="mt-15" text={addressNumberError.message} />
        )}
      </div>
    </>
  );
}
